import { GetUserBuyCountResp } from 'types/api/response/get-user-buy-count-resp'

import { api } from './api'

export const getUserBuyCount = () =>
  api.get<GetUserBuyCountResp>('/tracker_attributes', {
    params: {
      type: 'buy_debit_transactions',
    },
  })
